// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-77e38657]{color:#c81919}.favorite-connect-list[data-v-77e38657]{width:100%}.favorite-connect-grid[data-v-77e38657]{display:grid;grid-template-columns:repeat(3, minmax(0, 1fr));gap:24px}@media only screen and (min-width: 769px)and (max-width: 1365px){.favorite-connect-grid[data-v-77e38657]{grid-template-columns:repeat(2, minmax(0, 1fr))}}@media only screen and (max-width: 768px){.favorite-connect-grid[data-v-77e38657]{grid-template-columns:1fr}}", ""]);
// Exports
module.exports = exports;
